import { ReportSdk } from 'lib-klab-sdks';

function toIso(date: Date): string {
    return new Date(date.getTime()).toISOString();
}

function toLocalIso(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
}

export const screenshotReportsSdkMock = {
    getEmployeeScreenshots: (
        employeeId: number,
        startDate: string,
        endDate: string,
        startTime?: string,
        endTime?: string,
        search?: string,
        page = 0,
        size = 50,
    ): ReportSdk.ScreenshotReportsResponse => {
        const from = new Date(`${startDate}T${startTime || '00:00'}:00`);
        const endClock = endTime ? `${endTime}:59` : '23:59:59';
        const to = new Date(`${endDate}T${endClock}`);
        const safeFrom = Number.isNaN(from.getTime()) ? new Date() : from;
        const safeTo = Number.isNaN(to.getTime()) ? new Date(safeFrom.getTime() + 60 * 60 * 1000) : to;

        const base = Math.max(1, Number(employeeId) || 1) * 1000;
        const intervalMs = 30 * 60 * 1000;
        const points: Date[] = [];
        for (let cursor = safeFrom.getTime() + 15 * 60 * 1000; cursor <= safeTo.getTime(); cursor += intervalMs) {
            points.push(new Date(cursor));
        }

        const normalizedSearch = (search ?? '').trim().toLowerCase();
        const items = points.map((capturedAt, i) => ({
            screenshotId: base + i + 1,
            workSessionId: `ws-${employeeId}-${capturedAt.getTime()}`,
            capturedAt: toIso(capturedAt),
            capturedAtLocal: toLocalIso(capturedAt),
            downloadUrl: `https://placehold.co/1280x720/0f172a/e2e8f0/png?text=Screenshot+${i + 1}+employee+${employeeId}`,
        })).filter((item) => {
            if (!normalizedSearch) return true;
            const capturedAtLocal = item.capturedAtLocal.toLowerCase();
            const hour = item.capturedAtLocal.slice(11, 16);
            return capturedAtLocal.includes(normalizedSearch) || hour.includes(normalizedSearch);
        });

        const safeSize = Math.max(1, Number(size) || 50);
        const safePage = Math.max(0, Number(page) || 0);
        const start = safePage * safeSize;
        const content = items.slice(start, start + safeSize);

        return {
            metadata: {
                search,
                dateRange: { startDate, endDate },
                startTime,
                endTime,
                timeZone: 'America/Lima',
            },
            content,
            page: {
                page: safePage,
                size: safeSize,
                totalElements: items.length,
                totalPages: Math.ceil(items.length / safeSize),
            },
        };
    },
};
